<section class="lp-countries-carousel">
  <h2 class="lp-countries-carousel-title">{{ carouselTitle }}</h2>
  <div class="row">
    <div class="col-12">
      <div class="lp-countries-carousel-control-set">
        <button
          class="lp-countries-carousel-control-set-btn carousel-prev-btn"
          id="carousel-prev-btn"
          aria-label="Previous Slide"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
        <div class="lp-countries-carousel-control-set-diveder"></div>
        <button
          class="lp-countries-carousel-control-set-btn carousel-next-btn"
          id="carousel-next-btn"
          aria-label="Next Slide"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <div class="col-12">
      <swiper-container
        id="lp-countries-carousel-swiper"
        autoplay-delay="10000"
        autoplay-disable-on-interaction="false"
        keyboard="true"
        auto-height="false"
        #swiper
      >
        <swiper-slide *ngFor="let carouselItem of carouselSlidesSet">
          <div class="lp-countries-carousel-item-wrapper">
            <div class="lp-countries-carousel-item-top">
              <div class="lp-countries-carousel-item-header">“</div>
              <div class="lp-countries-carousel-item-body">
                <p>
                  {{ carouselItem.content }}
                </p>
              </div>
            </div>
            <div class="lp-countries-carousel-item-footer">
              <div class="lp-countries-carousel-item-footer-user-avatar">
                <img src="{{ carouselItem.userAvatar }}" alt="{{ carouselItem.userAvatar }}" />
              </div>
              <div class="lp-countries-carousel-item-footer-user-information">
                <h5>{{ carouselItem.userName }}</h5>
                <h6>{{ carouselItem.userCity }}</h6>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </div>
</section>
